// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2GOpF","content":"GlobalSearch_content__2c-BO"};